import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=df4adb8c&"
import script from "./Mobile.vue?vue&type=script&lang=js&"
export * from "./Mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsMobileCategoryCard: require('/usr/src/motec/components/products/MobileCategoryCard.vue').default})
